<template>
  <!-- 碎片盒子配置 -->
  <div class="debris_box_config-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="openDialog(1)">添加配置</el-button>
        </el-form-item>
        <el-form-item>
          <el-switch
            v-model="debris_status"
            active-text="开启碎片"
            inactive-text="关闭碎片"
            :active-value="1"
            :inactive-value="0"
            @change="changeEvent"
          ></el-switch>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="id" label="配置ID" align="center">
        </el-table-column>
        <el-table-column label="盒子碎片" align="center" width="400px">
          <template slot-scope="{ row }">
            <div class="debris-box">
              <div
                class="debris-info"
                v-for="item in row.debris"
                :key="item.id"
              >
                <div class="debris-info-img">
                  <img style="width: 50px" :src="item.image" alt="" />
                </div>
                <p>
                  {{ item.name }}
                </p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="probability" label="掉落概率" align="center">
        </el-table-column>
        <el-table-column prop="water_limit" label="单号消耗流水" align="center">
        </el-table-column>
        <el-table-column prop="minimum_water" label="保底次数" align="center">
        </el-table-column>
        <!-- <el-table-column prop="status" label="配置状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="danger" v-if="row.status === 0">关闭</el-tag>
            <el-tag type="success" v-if="row.status === 1">正常</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="action"
          label="操作"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="openDialog(2, row)"
              >编辑</el-button
            >
            <el-button type="primary" size="small" @click="openSelectBox(row)"
              >选择生效盒子</el-button
            >
            <el-button type="danger" size="small" @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加配置 -->
    <DebrisBoxDialog
      v-model="dialogInfos"
      :visible="addVisible"
      :type="dialogType"
      @close="addVisible = false"
      @refresh="getData()"
    ></DebrisBoxDialog>

    <!-- 添加限制盒子 -->
    <DebrisSelectBoxDialog
      :visible="setBoxVisible"
      v-model="dialogInfos"
      @close="setBoxVisible = false"
    ></DebrisSelectBoxDialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import DebrisBoxDialog from '../../components/debrisActivity/DebrisBoxDialog.vue'
import DebrisSelectBoxDialog from '@/components/debrisActivity/DebrisSelectBoxDialog'

export default {
  components: {
    DebrisBoxDialog,
    DebrisSelectBoxDialog
  },
  data() {
    return {
      setBoxVisible: false,//盒子排除弹窗显示标志
      addVisible: false,//添加队伍弹窗显示标志
      loading: false,//加载动画
      debris_status: 0,//秒杀开关,0是关闭，1是打开
      dialogType: 1,//1是添加 2是修改 默认是1
      dataList: undefined,//数据列表
      dialogInfos: undefined,//传给弹窗的数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()//获取数据列表
    this.getSwitchStatus()//按钮开关
  },
  methods: {
    getSwitchStatus() {
      //获取控制状态按钮
      getApiData('debris_config')
        .then(res => {
          if (res) {
            res.data ? this.debris_status = 1 : this.debris_status = 0
          }
        })
    },
    changeEvent() {
      //控制状态按钮
      let params = { "black": this.debris_status ? 1 : 0 }
      patchApiData('debris_config', params)
        .then(res => {
          this.$message.success('操作成功！')
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.debris_status = this.debris_status ? 0 : 1
        })

    },
    getData() {
      //获取数据列表
      this.loading = true
      getApiData('box_debris')
        .then(res => {
          this.dataList = res
          //设置底部导航条数据
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDialog(num, val) {
      //打开添加队伍弹窗
      this.addVisible = true
      if (num === 1) {
        this.dialogInfos = undefined
        this.dialogType = 1
      }
      if (num === 2) {
        this.dialogType = 2
        this.dialogInfos = JSON.parse(JSON.stringify(val))
      }
    },
    openSelectBox(rowInfo) {
      //打开盒子排除弹窗
      this.setBoxVisible = true
      this.dialogInfos = JSON.parse(JSON.stringify(rowInfo))
    },
    handleDelete(row) {
      //删除
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`box_debris/${row.id}`).then(() => {
          this.$message.success('删除成功')
          this.getData()
        })
      })
    },
    handleExport() {
      this.buttonLoading = true

      http
        .get(
          api + '',
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '胜利队伍人员.xlsx'
          })
        }).finally(() => {
          this.buttonLoading = false
        })
    },
  }

}
</script>
<style lang="less" scoped>
.debris-box {
  display: flex;
  justify-content: center;
  align-items: center;
  .debris-info {
    width: 50px;
    margin-right: 5px;
    .debris-info-img {
      border: 2px solid rgb(105, 202, 25);
      width: 50px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
    }
    p {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>